import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "config/firebase";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async () => {
    const email = process.env.REACT_APP_ADMIN_EMAIL!;
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/admin-article");
    } catch (err: any) {
      console.error(err);
      setError("Invalid password.");
    }
  };

  return (
    <div style={{ maxWidth: 300, margin: "auto", paddingTop: "5rem" }}>
      <h2>Admin Login</h2>
      <input
        type="password"
        placeholder="Enter admin password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={{ width: "100%", padding: 10, marginBottom: 10 }}
      />
      <button onClick={handleLogin} style={{ width: "100%", padding: 10 }}>
        Login
      </button>
      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
};

export default AdminLogin;
